/**
 * Pinta el color o imagen de cada swatch dentro del bloque "Siblings"
 * (fieldset.siblings) usando assets/swatches.json como fuente de datos.
 */
(() => {
  const DEFAULT_COLOR = '#E5E5E5';
  const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.svg'];

  const normalize = (text) => (text || '').toLowerCase().replace(/\s/g, '');

  const isImageFile = (value) => IMAGE_EXTENSIONS.some((ext) => value.toLowerCase().includes(ext));

  const findMatch = (colors, label) => {
    const entry = colors.find((item) => normalize(Object.keys(item)[0]) === label);
    return entry ? Object.values(entry)[0] : null;
  };

  const applySwatch = (el, colors, baseUrl) => {
    const label = el.getAttribute('data-swatch');
    if (!label) return;

    const match = findMatch(colors, normalize(label));

    if (!match) {
      el.style.setProperty('--swatch', DEFAULT_COLOR);
    } else if (isImageFile(match)) {
      el.style.setProperty('background-image', `url(${baseUrl}${match})`);
      el.style.setProperty('--swatch', '#888888');
    } else {
      el.style.setProperty('--swatch', match);
    }
  };

  const init = () => {
    const swatchElements = document.querySelectorAll('.siblings [data-swatch]');
    if (!swatchElements.length) return;

    const swatchesUrl = theme?.assets?.swatches;
    const baseUrl = theme?.assets?.base || '/';
    if (!swatchesUrl) return;

    fetch(swatchesUrl)
      .then((response) => response.json())
      .then(({ colors = [] }) => swatchElements.forEach((el) => applySwatch(el, colors, baseUrl)))
      .catch((error) => console.log('sibling-swatch-colors:', error));
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
